var map = {
	"./hemcap.jpg": 226,
	"./hemcap1.jpg": 227,
	"./hemcapmould.jpg": 228,
	"./hemcapmould1.jpg": 229,
	"./hemdial.jpg": 230,
	"./hemmould.jpg": 231
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;


//////////////////
// WEBPACK FOOTER
// ./src/images/medicalDevices nonrecursive \.(png|jpe?g|svg)$
// module id = 225
// module chunks = 0